<template>
  <div
    class="cultureCycleClear"
    style="width: 97.8%; border: 1px solid #e0e0e0; margin-left: 14px"
  >
    <div class="titleForm-container">
      {{ edit ? "编辑养殖周期" : "查看养殖周期" }}
    </div>
    <div :class="{ 'content-form-container': true, readonly: !edit }">
      <div class="main-container-form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="ruleForm"
        >
          <el-form-item label="基地" prop="fishBaseName">
            <el-select
              v-model="ruleForm.fishBaseName"
              disabled
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="3">
            <el-form-item label="塘口" prop="fishPondName" required>
              <el-col :span="18" :md="{ span: 17 }">
                <el-form-item>
                  <el-select
                    placeholder="请选择"
                    disabled
                    size="medium"
                    style="width: 100%"
                    v-model="ruleForm.fishPondName"
                  >
                    <el-option
                      v-for="(item, index) in fishPondNoBatch"
                      :key="index"
                      :label="item.fishPondName"
                      :value="item.fishPondId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" :md="{ span: 5 }" :offset="0.5">
                <el-form-item prop="batch">
                  <el-input
                    disabled
                    v-model.number="ruleForm.batch"
                    style="width: 100%"
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" :offset="0.5">
                <span>批</span>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item
            label="开始时间"
            value-format="yyyy-MM-dd"
            prop="startDate"
          >
            <el-col>
              <el-date-picker
                type="date"
                placeholder="选择日期"
                disabled
                v-model="ruleForm.startDate"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="清塘时间" prop="clearedDate">
            <el-col>
              <el-date-picker
                type="date"
                v-model="ruleForm.clearedDate"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
                :disabled="!edit || clearedPondTimeLocked"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="主养品种" class="mainVarietyFormItem">
            <el-row :gutter="10" type="flex" class="mainVarietyRow">
              <el-col :span="12">
                <el-select
                  v-model="mainCategoryItem"
                  clearable
                  filterable
                  :disabled="!edit"
                  class="mainVarietySelect"
                  placeholder="鱼分类"
                  size="medium"
                  @change="onMainCategoryChange"
                >
                  <el-option
                    v-for="item in fishGetCategory"
                    :key="item.key"
                    :label="item.value"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="mainFishItem"
                  clearable
                  filterable
                  :disabled="!edit || !mainCategoryItem"
                  class="mainVarietySelect"
                  :placeholder="mainCategoryItem ? '鱼种' : '请先选择鱼分类'"
                  size="medium"
                >
                  <el-option
                    v-for="item in fishGetCategoryName"
                    :key="item.key"
                    :label="item.value"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="饵料系数" prop="foodCoefficient">
            <el-input
              v-model="ruleForm.foodCoefficient"
              :disabled="!edit"
              clearable
              placeholder="可空"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注" prop="mark">
            <el-input
              v-model="ruleForm.mark"
              :disabled="!edit"
              placeholder="请输入备注"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="edit">
            <el-col :span="8">
              <el-button
                class="edit-save-btn"
                type="primary"
                @click="editSubmitForm('ruleForm')"
                >保存</el-button
              >
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')"
                >取消</el-button
              >
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import checkPermission from "../../../service/checkPermission.js";
export default {
  name: "cultureCycleClear",
  data() {
    return {
      edit: false,
      mainCategoryItem: null,
      mainFishItem: null,
      /** 与塘口最后批不一致(已开新周期)：清塘日只读 */
      clearedPondTimeLocked: false,
            id: this.$route.query.id,
      ruleForm: {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: "",
        foodCoefficient: "",
      },
      baseList: [], //基地列表
      rules: {
        fishBaseName: [
          { required: true, message: "请选择基地", trigger: "change" },
        ],
        fishPondName: [
          { required: true, message: "请选择塘口", trigger: "change" },
        ],
        batch: [
          {
            min: 0,
            max: 9999,
            pattern: /^[0-9]*$/,
            message: "批次格式有误",
            trigger: "blur",
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],

        foodCoefficient: [
          { validator: this.validateFoodCoefficient, trigger: "blur" },
        ],
        mark: [{ required: false, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  methods: {
    validateFoodCoefficient(rule, value, callback) {
      if (value !== 0 && !value) {
        callback();
      } else if (isNaN(value)) {
        callback(new Error("该值只能是数值类型"));
      } else if (value <= 0) {
        callback(new Error("请输入大于0的数值"));
      } else if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error("小数点后最多两位小数"));
      } else {
        callback();
      }
    },
    onMainCategoryChange(val) {
      this.mainFishItem = null;
      if (!val) {
        return;
      }
      this.getFishGetCategoryName(val.key).catch((err) => {
        console.dir(err);
      });
    },
    validateMainVarietyForSave() {
      if (this.mainCategoryItem && !this.mainFishItem) {
        this.$message.warning("已选择鱼分类，请选择鱼种");
        return false;
      }
      return true;
    },
    toMainFishPayload() {
      const c = this.mainCategoryItem;
      const f = this.mainFishItem;
      const v = this.ruleForm.foodCoefficient;
      const food =
        v === "" || v == null
          ? null
          : (() => {
              const n = Number(v);
              return isNaN(n) ? null : n;
            })();
      return {
        mainFishCategoryId: c ? c.key : null,
        mainFishCategoryName: c ? c.value : null,
        mainFishId: f ? f.key : null,
        mainFishName: f ? f.value : null,
        foodCoefficient: food,
      };
    },
    updateClearedPondTimeLockForForm() {
      this.clearedPondTimeLocked = false;
      const pondId = this.ruleForm.fishPondName;
      if (pondId == null || pondId === "") {
        return Promise.resolve();
      }
      return this.getLastBatchNo(pondId)
        .then((rsp) => {
          if (rsp && rsp.status === 200) {
            this.clearedPondTimeLocked =
              !!this.edit && Number(this.ruleForm.batch) !== Number(rsp.data);
          } else {
            this.clearedPondTimeLocked = !!this.edit;
          }
        })
        .catch(() => {
          this.clearedPondTimeLocked = !!this.edit;
        });
    },
    fillMainVarietyFromResponse(data) {
      if (!data) {
        return;
      }
      this.getFishGetCategory().catch((e) => {
        console.dir(e);
      });
      this.mainCategoryItem = null;
      this.mainFishItem = null;
      this.ruleForm.foodCoefficient =
        data.foodCoefficient != null && data.foodCoefficient !== ""
          ? data.foodCoefficient
          : "";
      if (data.mainFishCategoryId == null) {
        return;
      }
      this.mainCategoryItem = {
        key: data.mainFishCategoryId,
        value: data.mainFishCategoryName || "",
      };
      this.getFishGetCategoryName(data.mainFishCategoryId)
        .then((rsp) => {
          if (rsp && rsp.status === 200) {
            if (data.mainFishId != null && data.mainFishId !== undefined) {
              this.mainFishItem = {
                key: data.mainFishId,
                value: data.mainFishName || "",
              };
            } else {
              this.mainFishItem = null;
            }
          }
        })
        .catch((e) => {
          console.dir(e);
        });
    },
    ...mapActions(modules.pond, ["getFishPondNoBatch"]),
    ...mapActions(modules.cultureCycle, [
      "getHasClearedData", //已清塘数据,
      "editFishBatchData", //编辑-保存
      "getLastBatchNo",
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory",
      "getFishGetCategoryName",
    ]),
    ...mapActions(modules.base, [
      "getBaseList", //基地信息
    ]),
    //已清塘数据
    getHasClearedDatas() {
      this.getHasClearedData(this.id)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.ruleForm = rsp.data || [];
            this.fillMainVarietyFromResponse(this.ruleForm);
            if (this.ruleForm.fishBaseName) {
              this.getFishPondNoBatch(this.ruleForm.fishBaseName);
            }
            this.updateClearedPondTimeLockForForm();
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //编辑--保存
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.validateMainVarietyForSave()) {
            return;
          }
          let obj = {
            id: this.id, //行id
            fishPondName: this.ruleForm.fishPondName,
            batch: this.ruleForm.batch,
            startDate: this.ruleForm.startDate,
            clearedDate: this.ruleForm.clearedDate,
            remark: this.ruleForm.mark,
            ...this.toMainFishPayload(),
          };
          this.editFishBatchData(obj)
            .then((rsp) => {
              if (rsp.status === 200) {
                // this.showDialog = false;
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                history.go(-1);
              }
            })
            .catch((err) => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error",
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    },
  },
  async mounted() {
    this.edit = await checkPermission.initPagePermission(this.$route, { permissionId: 226 });
    this.getFishGetCategory().catch((e) => {
      console.dir(e);
    });
    this.getHasClearedDatas();
    this.baseList = await this.getBaseList(); //基地信息
  },
  computed: {
    ...mapState(modules.pond, ["fishPondNoBatch"]),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
  },
};
</script>

<style lang="stylus" scoped>
.cultureCycleClear
  .mainVarietyFormItem
    .el-form-item__content
      line-height: normal
  .mainVarietyRow
    width: 100%
    flex-wrap: nowrap
  .mainVarietySelect
    width: 100%
</style>
